import React from "react";

const VLSI = () => {
  return (
    <div>
      <h1>VLSI Notes</h1>
      <p>Here you will find VLSI study material.</p>
    </div>
  );
};

export default VLSI;